module.exports = __webpack_public_path__ + "img/T1C_xh_6.84244576.png";